/*------------------------------------------------
// File Name:PDM_Order.js
// File Description:PDM_Order API方法js接口
// Author:zxl
// Create Time:2022/12/16 15:02:54
//------------------------------------------------*/
import { axios } from '@/utils/request'

const api = {
   _order: "/PDM_RecvOrder"
}

export default api



//-------------------获取待接诊订单列表-------------------
export function GetOrderListByPage(parameter) {
    return axios({
        url: api._order + "/GetOrderListByPage",
        method: 'post',
        data: parameter
    })
}

//-------------------获取订单处方详情---------------
export function GetMZCFList(parameter) {
    return axios({
        url: api._order + "/GetMZCFList",
        method: 'post',
        data: parameter
    })
}


//-------------------接诊---------------
export function ReceivePatn(parameter) {
    return axios({
        url: api._order + "/ReceivePatn",
        method: 'post',
        data: parameter
    })
}


//-------------------发通知---------------
export function SendNotices(parameter) {
    return axios({
        url: api._order + "/SendNotices",
        method: 'post',
        data: parameter
    })
}

